import React, { useMemo } from 'react';
import { useMachineInfo } from '../../providers';
import { AsepticMachineStateIcon } from './BUMachineStateIcons/AsepticMachineState/AsepticMachineStateIcon';
import { DSIMachineStateIcon } from './BUMachineStateIcons/DSIMachineState/DSIMachineStateIcon';
import { ProsealMachineStateIcon } from './BUMachineStateIcons/ProsealMachineState/ProsealMachineStateIcon';
import { ProteinMachineStateIcon } from './BUMachineStateIcons/ProteinMachineState/ProteinMachineStateIcon';

export const MachineViewStateIcon = (): JSX.Element => {
  const { businessUnit } = useMachineInfo();

  const CachedIcon = useMemo(() => {
    if (businessUnit === 'aseptic') return <AsepticMachineStateIcon />;
    if (businessUnit === 'dsi') return <DSIMachineStateIcon />;
    if (businessUnit === 'proseal') return <ProsealMachineStateIcon />;
    if (businessUnit === 'pemea' || businessUnit === 'pna') return <ProteinMachineStateIcon />;
    return <></>;
  }, [businessUnit]);

  return CachedIcon;
};
